import React from 'react';
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import {
  Schema as SchemaIcon,
  DocumentScanner as DocumentScannerIcon,
  Assessment as AssessmentIcon,
  Psychology as PsychologyIcon
} from '@mui/icons-material';

const features = [
  {
    icon: <SchemaIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    title: 'Document Flows',
    description: 'Schema-driven extraction definitions. Visual flow builder. AI-assisted policy generation. Compliance linking.',
    color: '#1976d2'
  },
  {
    icon: <DocumentScannerIcon sx={{ fontSize: 40, color: '#2e7d32' }} />,
    title: 'Task Results',
    description: 'Bounding box field highlighting. Per-field validations. Event timeline logs. Object references. Inline edit & feedback.',
    color: '#2e7d32'
  },
  {
    icon: <AssessmentIcon sx={{ fontSize: 40, color: '#ed6c02' }} />,
    title: 'Evaluation & QA',
    description: 'Test extraction against ground-truth docs. Per-field accuracy metrics. Analytics dashboard. Export as CSV/XLSX.',
    color: '#ed6c02'
  },
  {
    icon: <PsychologyIcon sx={{ fontSize: 40, color: '#9c27b0' }} />,
    title: 'Fine-Tuning & Agents',
    description: 'Train custom models from evaluation datasets. Conversational agents with @mention context for policies, tasks, and documents.',
    color: '#9c27b0'
  }
];

const FeatureDeepDivesSection = () => (
  <Box
    sx={{
      py: 8,
      background: 'linear-gradient(135deg, #ddeeff 0%, #cce0f5 100%)',
      position: 'relative',
      zIndex: 1,
      borderTop: '1px solid rgba(25,118,210,0.12)',
      borderBottom: '1px solid rgba(25,118,210,0.12)'
    }}
  >
    <Container maxWidth="lg">
      <Typography variant="h3" align="center" sx={{ fontWeight: 700, mb: 2, color: '#1976d2' }}>
        Platform Capabilities
      </Typography>
      <Typography variant="body1" align="center" sx={{ color: '#555', mb: 6, maxWidth: 600, mx: 'auto' }}>
        Every feature purpose-built for document intelligence at scale.
      </Typography>
      <Grid container spacing={4}>
        {features.map((feature) => (
          <Grid item xs={12} sm={6} md={3} key={feature.title}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 3,
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                transition: 'all 0.4s ease-in-out',
                borderTop: `4px solid ${feature.color}`,
                border: '1px solid rgba(0,0,0,0.08)',
                '&:hover': {
                  transform: 'translateY(-10px)',
                  boxShadow: '0 16px 40px rgba(25, 118, 210, 0.2)'
                }
              }}
            >
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Box sx={{ mb: 2 }}>{feature.icon}</Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5, color: '#000' }}>
                  {feature.title}
                </Typography>
                <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.6 }}>
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default FeatureDeepDivesSection;
